import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';


import Geolocation from 'components/Geolocation';
import WeatherInfo from 'components/WeatherInfo';
import Loader from 'components/Loader'

import * as S from './styled';
import Clock from './date';


const Main = ({ wether, geoData, map, setMap, isCelsius, tLocation }) => {
  const [date, setDate] = useState(null);
  const [clock, setClock] = useState(null);

  useEffect(() => {
    if (geoData && geoData.offsetSec) {
      setClock(Clock(geoData.offsetSec));
    }
  }, [geoData]);

  useEffect(() => {
    if (clock) {
      const timer = setInterval(() => setDate(clock.tick()), 1000);
      return () => clearInterval(timer);
    }
  }, [clock, date]);

  if (geoData && wether && wether.todayWeather) {
    return (
      <S.Main>
        <S.MainContainer>
          <WeatherInfo date={date} wether={wether} geoData={geoData} isCelsius={isCelsius} tLocation={tLocation} />
          <Geolocation geoData={geoData} setMap={setMap} map={map} />
        </S.MainContainer>
      </S.Main>
    );
  }
  return (
    <S.Main>
      <S.MainContainer>
        <Loader />
      </S.MainContainer>
    </S.Main>
  );
};


export default Main;

Main.defaultProps = {
  wether: null,
  geoData: null,
  map: null,
  tLocation: '',
};

Main.propTypes = {
  wether: PropTypes.shape({
    todayWeather: PropTypes.shape({
      appTemp: PropTypes.number,
      temp: PropTypes.number,
      rh: PropTypes.number,
      code: PropTypes.number,
      icon: PropTypes.string,
      windSpd: PropTypes.number,
    }),
    fifteenWeather: PropTypes.arrayOf(
      PropTypes.shape({
        temp: PropTypes.number,
        icon: PropTypes.string,
        date: PropTypes.string,
      })
    ),
  }),
  geoData: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    DMS: PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string,
    }),
    location: PropTypes.string,
    offsetSec: PropTypes.number,
  }),
  map: PropTypes.shape({}),
  setMap: PropTypes.func.isRequired,
  isCelsius: PropTypes.bool.isRequired,
  tLocation: PropTypes.string,
};